import React, { Component } from 'react';
import ReactIdleTimer from 'react-idle-timer';
import { CLIENT_TIMEOUT } from '../containers/constants';

class IdleTimer extends Component {
    constructor(props) {
        super(props);
        this.idleTimer = React.createRef();
    }

    _onIdle = (e) => {
        this.redirectOnIdle();
    }

    redirectOnIdle = () => {
        /* this below snippet can be used for handling idle time out in all routes */
        // const { timeoutCount } = this.state;
        // if (timeoutCount === 1) {
        //     window.location.reload();
        // } else {
        //     this.setState({ timeoutCount: 1 });
        //     return <Redirect to="/" />;
        // }

        /* this bwlow snippet is used for handling idle time out in lq page */
        const route = window.location.pathname.split("/foryoursmallbiz/gborder")[1];
        const fiosRoute = window.location.pathname.split("/foryoursmallbiz/fiosorder")[1];
        const broadbandanywhereRoute = window.location.pathname.split("/foryoursmallbiz/internet")[1];
        if (route === '/' || route === "" || fiosRoute === '/' || fiosRoute === ""
                || broadbandanywhereRoute === '/' || broadbandanywhereRoute === "") {
            window.location.reload();
        }
    }

    render() {
        return (
            <div>
                <ReactIdleTimer
                    key="idleTimer"
                    ref={this.idleTimer}
                    timeout={CLIENT_TIMEOUT}
                    onIdle={this._onIdle}
                    debounce={500}
                />
            </div>
        )
    }
}

export default IdleTimer;